import { useEffect, useRef } from 'react';
import { useLocation } from 'wouter';
import { trackScrollDepth } from '@/lib/analytics';

export default function ScrollTracker() {
    const [location] = useLocation();
    const trackedDepths = useRef<Set<number>>(new Set());

    useEffect(() => {
        // Reset tracked depths on route change
        trackedDepths.current.clear();

        const handleScroll = () => {
            const winHeight = window.innerHeight;
            const docHeight = document.documentElement.scrollHeight;
            const scrollTop = window.scrollY;
            const scrollPercentage = Math.round((scrollTop / (docHeight - winHeight)) * 100);

            // We track 25%, 50%, 75%, 90%
            const depthMarkers = [25, 50, 75, 90];

            depthMarkers.forEach(depth => {
                if (scrollPercentage >= depth && !trackedDepths.current.has(depth)) {
                    trackedDepths.current.add(depth);
                    trackScrollDepth(depth, location);
                }
            });
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [location]);

    return null; // This component doesn't render anything
}
